/* Crew Ready Apparel - small site-wide behaviours.
 *
 * Evan 2026-09-18: every link that hands the shopper off to ftanaples.com (the custom-quote form,
 * the announcement bar, the footer) opens in a new tab, so nobody loses the kit they were looking
 * at. It is done here rather than per-template because most of those links come out of Shopify's
 * navigation menus, which have no open-in-new-tab setting, and they render in the header, the
 * mobile drawer and the footer. Internal links (/pages/contact) are deliberately left alone.
 */
(function () {
  var FTA = /(^|\.)ftanaples\.com$/i;

  function apply(a) {
    if (!a || a.target === '_blank') return;
    var host = '';
    try { host = new URL(a.href, window.location.href).hostname; } catch (e) { return; }
    if (!FTA.test(host)) return;          // mailto: and tel: give an empty hostname, so they skip
    a.target = '_blank';
    // noopener stops the new tab reaching back through window.opener. noreferrer is left off on
    // purpose so ftanaples.com still sees the store as the referrer.
    var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (rel.indexOf('noopener') < 0) rel.push('noopener');
    a.setAttribute('rel', rel.join(' '));
  }

  function mark(root) {
    if (!root || root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.nodeType === 1 && root.tagName === 'A') apply(root);
    if (!root.querySelectorAll) return;
    var links = root.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) apply(links[i]);
  }

  function init() {
    mark(document);
    // the cart drawer and the search results paint after load, so keep watching
    if (!window.MutationObserver) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) mark(added[j]);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Custom order tap counts (Evan 2026-09-26).
 *
 * One click listener for the whole store, so every Text / Call / Email / Get a quote link is counted: the new
 * buttons from snippets/crew-quote-cta.liquid and the older links in page copy, menus and the footer alike.
 * A tap sends the Clarity custom event cr_text, cr_call, cr_email or cr_quote and tags the session with
 * crew_cta = where it was tapped (hub, drawer or footer from data-crew-cta, "other" for any other link).
 * Clarity comes from its app embed; if it is blocked or not loaded yet nothing happens and the link still works.
 * Capture phase, so another handler stopping the click cannot hide it. Never calls preventDefault.
 */
(function () {
  if (window.__crewCtaTracking) return;
  window.__crewCtaTracking = true;

  var CTA_LINKS = 'a[href^="sms:"], a[href^="tel:"], a[href^="mailto:"], a[href*="ftanaples.com/request-a-quote"]';

  function kindOf(link) {
    var href = (link.getAttribute('href') || '').toLowerCase();
    if (href.indexOf('sms:') === 0) return 'text';
    if (href.indexOf('tel:') === 0) return 'call';
    if (href.indexOf('mailto:') === 0) return 'email';
    return 'quote';
  }

  try {
    document.addEventListener('click', function (event) {
      try {
        var target = event.target;
        if (!target || typeof target.closest !== 'function') return;
        var link = target.closest(CTA_LINKS);
        if (!link || typeof window.clarity !== 'function') return;
        window.clarity('event', 'cr_' + kindOf(link));
        window.clarity('set', 'crew_cta', link.getAttribute('data-crew-cta') || 'other');
      } catch (e) {}
    }, true);
  } catch (e) {}
})();
